import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { ColorPickerField, NumberField } from '@qfa/forms';
import { LocationFormContext } from '../../context';
import { DEFAULT_SEGMENT_COLOR, DEFAULT_SEGMENT_OPACITY } from '../../const';

export const useSegmentGeometryState = (disabled?: boolean) => {
  const { t } = useTranslation(['locations', 'common']);
  const { values, setValues, setDirty } = useContext(LocationFormContext);

  const segmentColor = values.color ?? DEFAULT_SEGMENT_COLOR;
  const segmentOpacity = values.opacity ?? DEFAULT_SEGMENT_OPACITY;

  const sectionOptions = useMemo(
    () => ({
      fieldNames: ['color, opacity'],
      name: t('locationGeometry'),
      hashRoute: 'locationGeometry',
      sectionId: 'locationGeometry',
      children: (
        <Box>
          <ColorPickerField
            type='colorPicker'
            id='color'
            name='color'
            label={t('common:color')}
            pickerZIndex={2}
            disabled={disabled}
            value={segmentColor}
            onChange={(_, value) => {
              setValues((prev) => ({
                ...prev,
                color: value,
              }));
              setDirty('color', true);
            }}
          />
          <NumberField
            type='number'
            id='opacity'
            name='opacity'
            label={t('common:opacity')}
            min={0}
            max={1}
            step={0.1}
            useStepper
            disabled={disabled}
            value={segmentOpacity}
            onChange={(_, value) => {
              setValues((prev) => ({
                ...prev,
                opacity: Number.parseFloat(value),
              }));
              setDirty('opacity', true);
            }}
          />
        </Box>
      ),
    }),
    [t, disabled, segmentColor, segmentOpacity, setValues, setDirty]
  );

  return { segmentColor, segmentOpacity, sectionOptions };
};
